// extracted by mini-css-extract-plugin
export default {"round":"AloneTask_round__FAJ5D","team":"AloneTask_team__6K4JN","name":"AloneTask_name__XYdKQ","type":"AloneTask_type__L9q5O"};